import ApiHelper from '../../../shared/ApiHelper';
import Settings from '../../../constants/Settings';
import { IWildlifeServiceObj } from '../../../shared/apiServices/IApiInterfaces';

const IdentificationGuideApiHelper = {
  getAllWildlife: async (): Promise<IWildlifeServiceObj[]> => {
    return (await ApiHelper.get(`${Settings.HabitatUrl}/wildlife`, true)).data;
  },
};

export default IdentificationGuideApiHelper;
